        <div class="modal-header">
            <button (click)="modalRef.hide()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            <div class="modal-title text-center mb-3">Unassign QR Memory {{(data && data.length > 1) ? 'Codes'  : 'Code'}}?</div>
            <div class="modal-subtitle text-center">Are you sure you want to unassign the selected QR Memory {{(data && data.length > 1) ? 'codes'  : 'code'}}?</div>
            <button (click)="modalRef.hide()" type="submit"  class="btn btn-outline-primary unassign-qr-btn margin-right-25">Cancel</button>
            <button (click)="unassignQrCode()" type="submit" class="btn primary unassign-qr-btn">Yes</button>
        </div>